import visigalogo from "../assets/visigalogo.png";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";

const Olevel = () => {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
      {/* First Portion (3 grid) */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("schoolName")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
            {t("schoolSub")}
          </span>
        </h1>
        <img
          src={visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Portion (6 grid) */}
      <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5">
        <h1 className="text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide text-neutral-900 dark:text-white">
          {t("olevel.title")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("olevel.subtitle")}
          </span>
        </h1>

        <p className="mt-4 text-lg lg:text-center text-neutral-900 dark:text-neutral-200 w-full">
          {t("olevel.desc1")}
        </p>

        <h1 className="mt-8 text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide text-neutral-900 dark:text-white">
          {t("olevel.subjectsTitle")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">
            {t("olevel.subjectsSubtitle")}
          </span>
        </h1>

        <p className="mt-4 text-lg lg:text-center text-neutral-900 dark:text-neutral-200 w-full">
          {t("olevel.desc2")}
        </p>

        <div className="mt-4 text-lg text-neutral-900 dark:text-neutral-200 w-full px-6 lg:px-10">
          <ul className="list-disc ml-6">
            <li><strong>{t("olevel.coreTitle")}</strong></li>
            <ul className="list-disc ml-6">
              <li>{t("olevel.core.civics")}</li>
              <li>{t("olevel.core.history")}</li>
              <li>{t("olevel.core.geography")}</li>
              <li>{t("olevel.core.kiswahili")}</li>
              <li>{t("olevel.core.english")}</li>
              <li>{t("olevel.core.biology")}</li>
              <li>{t("olevel.core.physics")}</li>
              <li>{t("olevel.core.chemistry")}</li>
              <li>{t("olevel.core.math")}</li>
            </ul>

            <li className="mt-4"><strong>{t("olevel.additionalTitle")}</strong></li>
            <ul className="list-disc ml-6">
              <li>{t("olevel.additional.bk")}</li>
              <li>{t("olevel.additional.computer")}</li>
            </ul>
          </ul>
        </div>
      </div>

      {/* Third Portion (3 grid) */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("motherText")}
        </p>
      </div>
    </div>
  );
};

export default Olevel;
